<template>
  <div>  
    <div class="d-flex flex-stack flex-wrap">
      <div class="page-title d-flex flex-column me-3 mt-3"> 
          <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">
            Description Type
          </h1>  
          <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
              <li class="breadcrumb-item text-gray-600">
                  <a href="#" class="text-gray-600 text-hover-primary"><router-link :to="{ name: 'Home' }">Home</router-link></a>
              </li> 
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">Settings</router-link></li>  
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'GeneralSettings' }">General Settings</router-link></li>  
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'ListTypes' }">List Types</router-link></li>    
              <li class="breadcrumb-item text-gray-600">Description Type</li> 
          </ul> 
      </div>  
        <div class="d-flex align-items-center py-1">
        <router-link to="/ListTypes">
              <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                <span class="ms-2 fs-7"> Return back to Settings </span>
              </button>
            </router-link>
        </div> 
      </div>  
      <div class="content flex-row-fluid mt-4" id="kt_content">
          <div class="card">
              <div class="card-header border-0 pt-6">
                  <div class="card-title">
                      <div class="d-flex align-items-center position-relative my-1">
                        <router-link to="/DescriptionTypeCreate">
                                <button type="button" class="btn btn-light-primary border border-primary me-3"><span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/>
                                    <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor"/>
                                    <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor"/>
                                    </svg>
                                  </span>Add Description Type</button>
                            </router-link>
                      </div>
                  </div>
                  <div class="card-toolbar">
                      <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                          <button type="button" class="btn btn-light-primary border border-primary" @click="getData()" data-kt-indicator="on">
                            <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path opacity="0.3" d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z" fill="currentColor"/>
                                    <path d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z" fill="currentColor"/>
                                    </svg>
                                </span>
                                <strong v-if="!this.isListProgressing"> List Description Types </strong> 
                                <span class="indicator-progress" v-if="this.isListProgressing">
                                    Getting Data... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span> 
                            </button>
                      </div>
                      <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                          <div class="fw-bolder me-5">
                          <span class="me-2" data-kt-customer-table-select="selected_count"></span>Selected</div>
                          <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">Delete Selected</button>
                      </div>
                  </div>
              </div>
              <div class="card-body pt-0">
                  <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="table-responsive min-h-300px">
                      <DxDataGrid :show-borders="true" 
                              key-expr="id" 
                              :data-source="lists" 
                              :allow-column-reordering="true"  
                              :allow-column-resizing="true" 
                              :column-auto-width="true" 
                              :row-alternatin-enabled="true"
                              :hover-state-enabled="true" 
                              :show-row-lines="true" 
                              @exporting="this.$onExporting($event , 'Description-Type-List')">

                              <DxFilterRow :visible="true"/>
                              <DxHeaderFilter :visible="true"/>
                              <DxGroupPanel :visible="true"/>      
                              <DxExport :enabled="true" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                              <DxPaging :page-size="20"/>
                              <DxPager :visible="true" :allowed-page-sizes="pageSizes" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true"/> 
                              <DxSearchPanel :visible="true"/>
                              <DxScrolling
                                    mode="virtual"
                                    row-rendering-mode="virtual"
                                    
                                />
                              <DxColumn data-field="auth_type" caption="Authorized User" header-cell-template="authorized-user-header" cell-template="authorized_user-cell-template"/> 
                              <DxColumn data-field="code" caption="Code" cell-template="code-cell-template"/> 
                              <DxColumn data-field="name" caption="Name" cell-template="name-cell-template"/>
                              <DxColumn data-field="type_name" caption="Type" cell-template="type_name-cell-template"/>                              
                              <DxColumn data-field="description_location" caption="Description Location" alignment="left" header-cell-template="description_location-header" cell-template="description_location-cell-template"/>
                              <DxColumn data-field="location_detail" caption="Location Detail" alignment="left" header-cell-template="location_detail-header" cell-template="location_detail-cell-template"/>
                              <DxColumn data-field="account_type" caption="Account Type" alignment="left" header-cell-template="account_type-header" cell-template="account_type-cell-template"/>
                              <DxColumn data-field="sales_type" caption="Sales Type" alignment="left" header-cell-template="sales_type-header" cell-template="sales_type-cell-template"/>
                              
                              
                              <DxColumn data-field="hide" caption="Is Hide?" alignment="center" cell-template="hide-cell-template" :allow-filtering="false"/>

                              <!-- Header Cell Templates -->
                              <template #authorized-user-header>
                                  <div> Authorized </div> <div> User </div>
                              </template> 
                              <template #description_location-header>
                                  <div> Description </div> <div> Location </div>
                              </template>
                              <template #location_detail-header>
                                  <div> Location </div> <div> Detail </div>
                              </template>
                              <template #account_type-header>
                                  <div> Account </div> <div> Type </div>
                              </template>
                              <template #sales_type-header>
                                  <div> Sales </div> <div> Type </div>
                              </template>

                              <!-- Cell Templates -->
                              <template #authorized_user-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 mb-1" @click="updateType(data.data)">
                                      {{data.data.auth_type}}
                                  </a>
                              </template>
                              <template #code-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 mb-1" @click="updateType(data.data)">
                                      <span class="badge badge-circle badge-light me-3" v-if="data.data.full_access == 1">
                                          <i class="bi bi-pencil text-gray-900"></i> 
                                      </span> 
                                      {{ data.data.code }}
                                  </a>
                              </template>
                              <template #name-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 fw-bold mb-1" @click="updateType(data.data)">
                                      {{ data.data.name }}
                                  </a>
                              </template> 
                              <template #type_name-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 mb-1" @click="updateType(data.data)">
                                      {{ data.data.type_name }}
                                  </a>
                              </template>
                              <template #description_location-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary text-end': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 mb-1" @click="updateType(data.data)">
                                      <span v-if="data.data.description_location == 0"> ALL </span>
                                      <span v-else> {{data.data.description_location_name}} </span>
                                  </a>
                              </template>
                              <template #location_detail-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary text-end': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 mb-1" @click="updateType(data.data)">
                                    <span v-if="data.data.location_detail == 0"> ALL </span>
                                    <span v-if="data.data.description_location == 1"> 
                                      <span v-if="data.data.location_detail == 1"> Sales </span>
                                      <span v-if="data.data.location_detail == 2"> Purchase </span>
                                      <span v-if="data.data.location_detail == 3"> Sales Return </span>
                                      <span v-if="data.data.location_detail == 4"> Purchase Return </span>
                                    </span>
                                    <span v-if="data.data.description_location == 2 || data.data.description_location == 3 
                                    || data.data.description_location == 4 || data.data.description_location == 6 || data.data.description_location == 1"> 
                                      <span v-if="data.data.location_detail == 1"> Incoming </span>
                                      <span v-if="data.data.location_detail == 2"> Outgoing </span>
                                    </span>
                                    <span v-if="data.data.description_location == 7 || data.data.description_location == 8 || data.data.description_location == 9"> 
                                      <span v-if="data.data.location_detail == 1"> Debit </span>
                                      <span v-if="data.data.location_detail == 2"> Credit </span>
                                    </span>
                                    <span v-if="data.data.description_location == 16"> 
                                      <span v-if="data.data.location_detail == 1"> Income Closing </span>
                                      <span v-if="data.data.location_detail == 2"> Expense Closing </span>
                                      <span v-if="data.data.location_detail == 3"> Cost Closing </span>
                                      <span v-if="data.data.location_detail == 4"> Other Income Closing </span>
                                      <span v-if="data.data.location_detail == 5"> Other Expense Closing </span>
                                    </span>
                                  </a>
                              </template>
                              <template #account_type-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary text-end': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 mb-1" @click="updateType(data.data)">
                                      <span v-if="data.data.account_type_name == 'Undefined'"> ALL </span>
                                      <span v-if="data.data.account_type_name !== 'Undefined'"> {{data.data.account_type_name}} </span>
                                  </a>
                              </template>
                              <template #sales_type-cell-template="{ data }">
                                  <a href="#" :class="{'text-hover-primary text-end': data.data.full_access == 1, 'pe-none': data.data.full_access == 0}"
                                    class="text-gray-900 mb-1" @click="updateType(data.data)">
                                      <span v-if="data.data.sales_type == 0"> - </span>
                                      <span v-if="data.data.sales_type == 1"> Domestic </span>
                                      <span v-if="data.data.sales_type == 2"> Overseas </span>
                                  </a>
                              </template> 
                              <template #hide-cell-template="{ data }">
                                    <input class="form-check-input" type="checkbox" value="" id="hide" v-model="data.data.hide" @change="setListItemHide(data.data)">
                              </template>
                      </DxDataGrid>
                    </div>
                  </div> 
              </div>
          </div> 
      </div> 
  </div> 
</template>

<style scoped>
.mh-300 {
    min-height: 300px;
}
</style>

<script>
// Component Alias: `EXTL001`  
import axios from 'axios' 
  
import moment from 'moment';
// import Swal from 'sweetalert2';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxScrolling } from 'devextreme-vue/data-grid';

 
export default {
  name: "DescriptionTypeList",
  components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxScrolling
  },
  data() {
    return {
      lists: [],
      searchbar: '',
      isListProgressing: false
    };
  },
  computed: {
    searchableList() {
      return this.lists.filter(p => { 
        return p.name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1;
      });
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY HH:mm')
        }
      }
    }
  },
  methods: {
    getData() {
      this.$Progress.start();
      this.lists = [];
      this.isListProgressing = true;
      const params = {
        session_id: this.$getUser().session_id
      };
      axios.post('/api/Lists/GetDescriptionTypeList', params, {'Content-Type': 'application/json'})
        .then((response) => { 
          this.lists = response.data; 
          this.lists.forEach(element => {
            if (element.type_id == 1) {element.type_name = 'Manuel';}
            if (element.type_id == 2) {element.type_name = 'Automatic';}
          });
          this.$setSessionStorage('data' + '_DTPL001', response.data)
          this.$Progress.finish();
          setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
        .catch(function (error) {
          console.error(error); 
          this.$setSessionStorage('data' + '_DTPL001', null)
          this.$Progress.finish();
          setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        });
    },
    updateType(item){ 
        if (item.full_access == 0) return;
        this.$setSessionStorage("record_id", item.id);
        this.$router.push({ name: 'DescriptionTypeUpdate' });
    },
    setListItemHide(data) {
        this.$swal.fire({
            title: data.hide == true ? 'Are you sure to hide this selected data from the lists?' : 'Are you sure to show this selected data from the lists?',
            confirmButtonColor: '#f1416c',
            showDenyButton: false,
            showCancelButton: true,
            icon: 'warning',
            confirmButtonText: 'Yes'
        }).then((result) => { 
            if (result.isConfirmed) {
                const params = {
                  session_id: this.$getUser().session_id,
                  list_type: 11,
                  hide: data.hide,
                  id: data.id
                };      
                params.hide = params.hide == true ? 1: 0;
                axios.post('/api/Lists/SetListItemHide', params, {'Content-Type': 'application/json'})
                  .then((response) => { 
                          if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                              this.getData();
                          } 
                  })
                  .catch(function (error) {
                      console.error(error);
                      this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
                  });
            }
            else{
                data.hide = !data.hide;
            }
        }); 
    }
  },
  created() {
    this.$setSessionStorage('record_id', null); 
    if(this.$getSessionStorage('refreshList')){
        this.getData();
        this.$removeSessionStorage('refreshList'); 
    } 
    else{
        this.lists = [];
    }
  }
}; 
</script>